import { Modal } from 'react-bootstrap';
import './ModalLayout.scss';

const ModalLayout = ({ modalBody, Show, handleClose, ModalTitle, adminBodyAddUser }) => {


    return (
        <Modal
            id="defaultModalLayout"
            size="lg"
            show={Show}
            onHide={handleClose}
            aria-labelledby="example-modal-sizes-title-lg"
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                    {ModalTitle}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {modalBody}
            </Modal.Body>
            <Modal.Footer>
                {adminBodyAddUser}
                <button onClick={() => handleClose(true)} className="px-4 closeButton button BG_LIGHT_RED text-white">Close</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalLayout;